import {memo} from 'react'

import SidebarFooter from '../../SidebarFooter/SidebarFooter'

import {usePipelineSettingsFooter} from './PipelineSettingsFooter.hooks'

import ConfirmationDialog from 'src/components/common/ConfirmationDialog/ConfirmationDialog'
import IconButton from 'src/components/common/IconButton/IconButton'

function PipelineSettingsFooter() {
  const title = 'Delete pipeline'
  const {
    name,
    portalTarget,
    isLoading,
    isDialogShown,
    showDialog,
    hideDialog,
    handlerConfirmDeletePipelineButtonClick,
  } = usePipelineSettingsFooter()

  return (
    <SidebarFooter>
      <IconButton title={title} icon={'trash'} onClick={showDialog} danger>
        {title}
      </IconButton>
      <ConfirmationDialog
        show={isDialogShown}
        title={`Delete pipeline ${name}?`}
        confirmButtonText={'Delete'}
        onConfirm={handlerConfirmDeletePipelineButtonClick}
        onCancel={hideDialog}
        loader={isLoading}
        portalTarget={portalTarget}
      />
    </SidebarFooter>
  )
}

export default memo(PipelineSettingsFooter)
